import { render, staticRenderFns } from "./DatePickerOld.vue?vue&type=template&id=04f43a70&scoped=true"
import script from "./DatePickerOld.vue?vue&type=script&lang=js"
export * from "./DatePickerOld.vue?vue&type=script&lang=js"
import style0 from "./DatePickerOld.vue?vue&type=style&index=0&id=04f43a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f43a70",
  null
  
)

export default component.exports